import { doTimeSlotsIntersect } from '@kaidam/fc-shared/src/booking/utils'
import {
  IMeta_ProjectConfig_Palette,
} from '@kaidam/fc-shared/src/types/schema/project_config'

export {
  API_URL,
} from '@kaidam/fc-shared/src/constants'

export const REFRESH_TOKEN_DELAY = 1000 * 60

export const ROUTE_LOGGED_IN = 'dashboard'
export const ROUTE_LOGGED_OUT = 'login'

export const TOPBAR_HEIGHT = 60
export const DRAWER_COLLAPSED_WIDTH = 70
export const DRAWER_WIDTH = 300
export const SIDEBAR_WIDTH = 300
export const APP_TITLE = 'Franchise Cloud'
export const APP_LOGO = '/img/fc-logo-horizontal-white.png'
export const APP_LOGO_HEARTS = '/img/fc-logo-hearts-white.png'
export const APP_LOGO_TEXT = '/img/fc-logo-text-white.png'
export const APP_HEADER = '/img/fc_appbar_header.png'
export const APP_ARIA_LOGO = '/img/aria-logo.png'
export const APP_ARIA_TEXT = '/img/aria-text.png'
export const APP_FF_LOGO_TEXT = '/img/ff-logo-text.png'
export const APP_FF_LOGO = '/img/ff-logo.png'
export const APP_FF_HEADER = ''

export const APP_PALETTE: IMeta_ProjectConfig_Palette = {
  primary: {
    main: '#6991F2',
  },
  secondary: {
    main: '#AF56C2',
  },
  background: {
    main: '#FAFBFF',
  },
}